import { Form, FormSpy } from 'react-final-form'
import { InfoOutlined } from '@material-ui/icons'
import { Button, Grid, IconButton, makeStyles, Paper, Typography } from '@material-ui/core'
import MyTextfield from '../../../../../control/textfield/textfield'
import MyDatePicker from '../../../../../control/datepicker/datepicker'
import MySelectCtrl from '../../../../../control/select/select'
import MyCheckbox from '../../../../../control/checkbox/checkbox'
import useTranslate from '../../../../../i18n/useTranslate'
import useRouter from '../../../../../router/useRouter'
import Tooltip from '../../../../../control/tooltip/tooltip'
import useTitleName from '../../../../../services/um/lookups/useTitleName'
import usePosition from '../../../../../services/um/lookups/usePosition'
import { selectRequired, textRequired } from '../../../../../utilities/validate'
import useResearcherType from '../../../../../services/um/lookups/useResearcherType'
import { useEffect, useRef, useState } from 'react'
import Dialog, { DialogType } from '../../../../../control/dialog/dialog'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import { InputAdd, ResearcherType } from '../../../../../services/manageExternalProject/searchFormExternalProjectType'
import useManageExternalProject from '../../../../../services/manageExternalProject/useManageExternalProject'
import useLoading from '../../../../../control/loading/useLoading'
import { RoutePath } from '../../../../../router/routesConfig'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import useLookupService from '../../../../../services/lookup/useLookupService'

interface dataLookUp {
    id: number
    name_th: string
    name_en: string
}

interface LocaitonDataProps {
    data: InputAdd
}

const FormAddExternalProject = () => {
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const [initialValueForm, setInitialValueForm] = useState<InputAdd>()
    const [educationList, setEducationList] = useState<{ label: string; value: string }[]>([])
    const dialogTwoRef = useRef<Record<string, Function>>()
    const translate = useTranslate()
    const classes = useStyles()
    const router = useRouter()
    const { state } = useTitleName()
    const { position } = usePosition()
    const { researcherType } = useResearcherType()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const { postNewProject, editProject } = useManageExternalProject()
    const { loadingClose, loadingOpen } = useLoading()
    const location = useLocation<LocaitonDataProps>()
    const certificateIDRef = useRef<string>()
    const defaultDate = moment(new Date()).format('YYYY-MM-DD')
    const callLookup = useLookupService()

    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const prefixName = state.map((item: dataLookUp) => {
        return {
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })
    const positionName = position.map((item: dataLookUp) => {
        return {
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })
    const researcher = researcherType.map((item: dataLookUp) => {
        return {
            value: item.id.toString(),
            label: lang === 'en' ? item.name_en : item.name_th,
        }
    })
    const educationLevel = async () => {
        const res = await callLookup.getEducationLevel()
        const formatData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setEducationList(formatData)
    }
    const handleAfterCloseCreateSuccess = () => {
        setConfigDialog({})
        router.goTo(RoutePath.manageExternalProject)
    }

    const handleSubmit = (values: InputAdd) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',

            onClickConfirm: async () => {
                try {
                    loadingOpen()
                    if (location.pathname.includes('/add')) {
                        const allValue = {
                            ...values,
                            projectID: null,
                        }
                        const response = await postNewProject(allValue)
                        if (response.result.status === 201) {
                            certificateIDRef.current = response.result.data.result.certificateID
                            setConfigDialog({
                                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                                content: (
                                    <>
                                        <p>{`${translate.get('ALERT.CONTENT.SAVE_SUCCESS')} ${translate.get(
                                            'LABEL.COA_NO',
                                        )}: "${certificateIDRef.current}"`}</p>
                                    </>
                                ),
                                type: 'alert-message',
                                onAfterClose: handleAfterCloseCreateSuccess,
                            })
                        }
                    } else {
                        const allValuseEdit: InputAdd = { ...values, projectID: String(initialValueForm?.projectID) }
                        const response = await editProject(allValuseEdit)
                        if (response.result.status === 201) {
                            setConfigDialog({
                                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                                type: 'alert-message',
                                onAfterClose: () => {
                                    setConfigDialog({})
                                    router.goTo(RoutePath.manageExternalProject)
                                },
                            })
                        }
                    }
                } catch (error) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.WARNING'),
                        content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                        type: 'alert-message',
                    })
                    console.log(error)
                } finally {
                    loadingClose()
                }
            },
        })
        dialogTwoRef.current?.openDialog()
    }

    const handleToManageExternalPage = (dirty: Boolean) => {
        if (location.pathname.includes('/edit')) {
            dirty = true
        }
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    router.goTo(RoutePath.manageExternalProject)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            router.goTo(RoutePath.manageExternalProject)
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const handleDirtyChange = (props: any) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }

    const formattingInitialData = () => {
        if (location.state?.data) {
            const initialValue = {
                ...location.state?.data,
            }
            setInitialValueForm(initialValue)
        } else {
            const initialValue = {
                ...location.state?.data,
                certificateDate: defaultDate,
            }
            setInitialValueForm(initialValue)
        }
    }

    useEffect(() => {
        formattingInitialData()
        educationLevel()
    }, [])
    return (
        <>
            <Paper variant="outlined" className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.title}>
                            {translate.get('LABEL.EXTERNAL_PROJECT_MANAGEMENT')}
                        </Typography>
                    </Grid>

                    <Form
                        onSubmit={handleSubmit}
                        initialValues={initialValueForm}
                        render={({ handleSubmit, dirty, values, form }) => {
                            const isShowEducationLevel = String(values?.researcherType) === ResearcherType.student
                            const isShowOtherAcademicLevel = String(values?.academicLevel) !== '6'
                            const isShowOtherPrefix = String(values?.prefixID) !== '5'

                            const handleChangeResearcherType = (val: string) => {
                                if (val === '1') {
                                    form.change('academicLevel', null)
                                    form.change('otherAcademicLevelTh', null)
                                    form.change('otherAcademicLevelEn', null)
                                } else {
                                    form.change('educationLevel', null)
                                }
                            }
                            const handleChangeTitleName = (val: string) => {
                                if (val !== '5') {
                                    form.change('titleNameOtherTh', null)
                                    form.change('titleNameOtherEn', null)
                                }
                            }
                            const handleChangeAcademicLevel = (val: string) => {
                                if (val !== '6') {
                                    form.change('otherAcademicLevelTh', null)
                                    form.change('otherAcademicLevelEn', null)
                                }
                            }
                            return (
                                <Grid container item className={classes.containerForm}>
                                    <Grid item xs={12} sm={6} className={classes.inbox}>
                                        <MyTextfield
                                            name="certificateID"
                                            materialInputProps={{
                                                disabled: true,
                                                label: translate.get('LABEL.COA_NO'),
                                                placeholder: translate.get('LABEL.COA_NO'),
                                                size: 'small',
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} className={classes.inbox}>
                                        <MyDatePicker
                                            name="certificateDate"
                                            label={translate.get('LABEL.EXTERNAL_PROJECT_CERTIFICATE_DATE')}
                                            size="small"
                                            required
                                        />
                                    </Grid>

                                    <Grid container item xs={12}>
                                        <Grid item xs={12} md={6} lg={6} className={classes.inbox}>
                                            <MySelectCtrl
                                                name="researcherType"
                                                label={translate.get('LABEL.RESEARCHER_TYPE')}
                                                placeholder={translate.get('LABEL.RESEARCHER_TYPE')}
                                                size="small"
                                                option={[...researcher]}
                                                required
                                                validates={[selectRequired(translate.get('MESSAGE.M016'))]}
                                                defaultValue={[String(initialValueForm?.researcherType)]}
                                                onChangeSelect={handleChangeResearcherType}
                                            />
                                        </Grid>

                                        {isShowEducationLevel && (
                                            <Grid item xs={12} md={6} lg={6} className={classes.inbox}>
                                                <MySelectCtrl
                                                    name="educationLevel"
                                                    label={translate.get('LABEL.EDUCATION_LEVEL')}
                                                    placeholder={translate.get('LABEL.PLEASE_SELECT')}
                                                    option={[...educationList]}
                                                    validates={[selectRequired(translate.get('MESSAGE.M016'))]}
                                                    defaultValue={[String(initialValueForm?.educationLevel)]}
                                                    required
                                                />
                                            </Grid>
                                        )}
                                    </Grid>

                                    {!isShowEducationLevel && (
                                        <>
                                            <Grid item xs={12} sm={6} className={classes.inbox}>
                                                <MySelectCtrl
                                                    name="academicLevel"
                                                    label={translate.get('UM.USERGROUP-ADD.POSITION')}
                                                    placeholder={translate.get('UM.USERGROUP-ADD.POSITION')}
                                                    size="small"
                                                    icon={
                                                        <Tooltip
                                                            title={translate.get('MESSAGE.M024', [
                                                                translate.get('UM.USERGROUP-ADD.DOCTOR'),
                                                            ])}
                                                        >
                                                            <IconButton size="small">
                                                                <InfoOutlined className={classes.infoIcon} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                    required
                                                    option={[...positionName]}
                                                    validates={[selectRequired(translate.get('MESSAGE.M016'))]}
                                                    defaultValue={[String(initialValueForm?.academicLevel)]}
                                                    onChangeSelect={handleChangeAcademicLevel}
                                                />
                                            </Grid>

                                            <Grid container item xs={12} sm={6}>
                                                <Grid item xs={12} sm={6} className={classes.inbox}>
                                                    <MyTextfield
                                                        name="otherAcademicLevelTh"
                                                        materialInputProps={{
                                                            disabled:
                                                                isShowOtherAcademicLevel &&
                                                                !initialValueForm?.otherAcademicLevelTh,
                                                            label: translate.get('UM.PROFILE.POSITION_OTHER_TH'),
                                                            placeholder: translate.get('UM.PROFILE.POSITION_OTHER_TH'),
                                                            size: 'small',
                                                        }}
                                                        required={!isShowOtherAcademicLevel}
                                                        fontSize={16}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6} className={classes.inbox}>
                                                    <MyTextfield
                                                        name="otherAcademicLevelEn"
                                                        materialInputProps={{
                                                            disabled:
                                                                isShowOtherAcademicLevel &&
                                                                !initialValueForm?.otherAcademicLevelEn,
                                                            label: translate.get('UM.PROFILE.POSITION_OTHER_EN'),
                                                            placeholder: translate.get('UM.PROFILE.POSITION_OTHER_EN'),
                                                            size: 'small',
                                                        }}
                                                        required={!isShowOtherAcademicLevel}
                                                        fontSize={15}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={12} className={classes.fullInput}>
                                        <MyCheckbox
                                            name="isPhd"
                                            label={translate.get('UM.PROFILE.ACADEMIC_POSITION_DR')}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} className={classes.inbox}>
                                        <MySelectCtrl
                                            name="prefixID"
                                            label={translate.get('UM.PROFILE.PREFIX')}
                                            placeholder={translate.get('UM.PROFILE.PREFIX')}
                                            size="small"
                                            icon={
                                                <Tooltip title={translate.get('MESSAGE.M025')}>
                                                    <IconButton size="small">
                                                        <InfoOutlined className={classes.infoIcon} />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            option={[...prefixName]}
                                            required
                                            validates={[selectRequired(translate.get('MESSAGE.M016'))]}
                                            defaultValue={[String(values.prefixID)]}
                                            onChangeSelect={handleChangeTitleName}
                                        />
                                    </Grid>

                                    <Grid container item xs={12} sm={6}>
                                        <Grid item xs={12} sm={6} className={classes.inbox}>
                                            <MyTextfield
                                                name="titleNameOtherTh"
                                                materialInputProps={{
                                                    disabled: isShowOtherPrefix && !initialValueForm?.titleNameOtherTh,
                                                    label: translate.get('UM.PROFILE.PREFIX_OTHER_TH'),
                                                    placeholder: translate.get('UM.PROFILE.PREFIX_OTHER_TH'),
                                                    size: 'small',
                                                }}
                                                required={!isShowOtherPrefix}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} className={classes.inbox}>
                                            <MyTextfield
                                                name="titleNameOtherEn"
                                                materialInputProps={{
                                                    disabled: isShowOtherPrefix && !initialValueForm?.titleNameOtherEn,
                                                    label: translate.get('UM.PROFILE.PREFIX_OTHER_EN'),
                                                    placeholder: translate.get('UM.PROFILE.PREFIX_OTHER_EN'),
                                                    size: 'small',
                                                }}
                                                required={!isShowOtherPrefix}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={6} className={classes.inbox}>
                                        <MyTextfield
                                            name="nameTh"
                                            materialInputProps={{
                                                disabled: false,
                                                label: translate.get('LABEL.RESEARCHER_FULLNAME_TH'),
                                                placeholder: translate.get('LABEL.RESEARCHER_FULLNAME_TH'),
                                                size: 'small',
                                            }}
                                            validates={[textRequired(translate.get('MASSAGE.M015'))]}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} className={classes.inbox}>
                                        <MyTextfield
                                            name="nameEn"
                                            materialInputProps={{
                                                disabled: false,
                                                label: translate.get('LABEL.RESEARCHER_FULLNAME_EN'),
                                                placeholder: translate.get('LABEL.RESEARCHER_FULLNAME_EN'),
                                                size: 'small',
                                            }}
                                            required
                                            validates={[textRequired(translate.get('MASSAGE.M015'))]}
                                        />
                                    </Grid>

                                    <Grid item xs={12} className={classes.fullInput}>
                                        <MyTextfield
                                            name="projectNameTh"
                                            materialInputProps={{
                                                disabled: false,
                                                label: translate.get('EXPORT.EXCEL.PROJECT-NAME-TH'),
                                                placeholder: translate.get('EXPORT.EXCEL.PROJECT-NAME-TH'),
                                                size: 'small',
                                            }}
                                            required
                                            validates={[textRequired(translate.get('MASSAGE.M015'))]}
                                        />
                                    </Grid>

                                    <Grid item xs={12} className={classes.fullInput}>
                                        <MyTextfield
                                            name="projectNameEn"
                                            materialInputProps={{
                                                disabled: false,
                                                label: translate.get('EXPORT.EXCEL.PROJECT-NAME-EN'),
                                                placeholder: translate.get('EXPORT.EXCEL.PROJECT-NAME-EN'),
                                                size: 'small',
                                            }}
                                            required
                                            validates={[textRequired(translate.get('MASSAGE.M015'))]}
                                        />
                                    </Grid>

                                    <Grid container item xs={12} justify="flex-end" className={classes.boxBtn}>
                                        <Button
                                            variant="contained"
                                            className={classes.btnClose}
                                            onClick={() => handleToManageExternalPage(dirty)}
                                            size="small"
                                        >
                                            {translate.get('BUTTON.CLOSE')}
                                        </Button>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            type="submit"
                                            onClick={handleSubmit}
                                            className={classes.btnSave}
                                            size="large"
                                        >
                                            {translate.get('BUTTON.SAVE')}
                                        </Button>
                                    </Grid>
                                    <Dialog onRef={onRefDialogTwo} {...configDialog} />
                                    <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                                </Grid>
                            )
                        }}
                    />
                </Grid>
            </Paper>
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '15px',
        marginBottom: '15px',
    },
    inbox: {
        padding: '10px 15px',
    },
    title: {
        fontWeight: 'bold',
        padding: '20px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    fullInput: {
        paddingRight: '10px',
        paddingLeft: '20px',
    },
    btnSave: {
        marginLeft: '20px',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        fontSize: '16px',
    },
    btnClose: {
        boxShadow: 'none',
        width: '114px',
        heigth: '40px',
        fontSize: '16px',
    },
    containerForm: {
        padding: '20px 35px',
    },
    boxBtn: {
        padding: '20px 10px 20px 0px',
    },
    infoIcon: {
        fontSize: '18px',
    },
}))

export default FormAddExternalProject
